import { router } from "@smakecloud/api-client-helper";
import { get } from "./get";
import { list } from "./list";
import { post } from "./post";
import { put } from "./put";
import { createTestFile } from "./testfile";

export const remoteStorages = router({
    createTestFile,
    get,
    list,
    post,
    put,
});
